import React from 'react'
import { useQueryParams } from '@fs/zion-router'
import PlaceReportsRegionsNavPanel from './PlaceReportsRegionsNavPanel'
import PlaceReportsCountriesNavPanel from './PlaceReportsCountriesNavPanel'
import DivisionsNavPanel from './PlaceReportsDivisionsNavPanel'
import { usePlaceReportsPageData } from '../../PlaceReportsProvider'

export default function PlaceReportsLeftNavPanel(): JSX.Element {
  const { getRegion, getCountryAndRegion } = usePlaceReportsPageData()
  const { query } = useQueryParams()
  const { region, country, division } = query

  const countryData = country ? getCountryAndRegion(country)?.country : null
  const regionData = region ? getRegion(region) : null

  if (division) {
    return <DivisionsNavPanel />
  }

  if (country && countryData?.divisions?.length && countryData.divisions.length > 0) {
    return <DivisionsNavPanel />
  }

  if (region && regionData?.countries?.length && regionData.countries.length > 0) {
    return <PlaceReportsCountriesNavPanel />
  }

  return <PlaceReportsRegionsNavPanel />
}
